/* eslint-disable @typescript-eslint/no-unused-vars */
import { useDispatch } from 'react-redux';
import {
  useGetModalMetaData,
  // useGetModalMetaData,
  useIsPlainModalOpenSelector,
} from '../../../store/modules/modals/modals.selector';
import {
  closeModalByNameAction,
  PlainModals,
} from '../../../store/modules/modals/modals.reducer';
import { ModalContainer } from '../../../components/modals/modal-container/modal-container';
import React, { useContext, useEffect, useMemo } from 'react';
import { ApiContext } from '../../../components/providers/api-provider/api-provider';
import {
  // IDENTITY_DETAILS_RISK_REASON_TABLE,
  // IDENTITY_RISK_REASON_POLICY_LINK,
  PRODUCTIVITY_INSIGHTS_TABLE,
} from 'constants/test-ids';
import { Box } from '@mui/material';
import {
  RightTableFiltersContainer,
  TableFiltersContainer,
} from 'components/table/styles';
// import { FilterChips } from 'components/table/table-filters-components/filter-chips/chips-list';
// import { SearchInput } from 'components/table/table-filters-components/search-input/search-input';
import { TableNamesOfFilters } from 'components/table/table-filters-components/filter-renderer/filter-renderer';
import {
  CommitsTableStructure,
  PullsTableStructure,
} from '../constants/constants';
import { TableComponent } from 'components/table/table-component/table-component';
import dayjs from 'dayjs';
import { ContainerWithLoader } from 'components/container-with-loader/container-with-loader';
import { setTotalItems } from 'store/modules/pagination/pagination.reducer';
import { usePaginationSelector } from 'store/modules/pagination/pagination.selector';
import { DatePickerNames } from 'constants/date-picker-ids';
import { useDatePickerSelector } from 'store/modules/date-picker/date-picker.selector';

export const ProductivityInsightsModal = () => {
  const dispatch = useDispatch();
  const apiContext = useContext(ApiContext);
  const metaData = useGetModalMetaData();

  const tableId = TableNamesOfFilters.PRODUCTIVITY_INSIGHTS_TABLE;
  // const [searchQuery, setSearchQuery] = useState('');

  const { activityStartDate: sDate, activityEndDate: eDate } =
    useDatePickerSelector(DatePickerNames.PRODUCTIVITY_INSIGHTS);

  let { itemsPerPage, page } = usePaginationSelector();

  const isRiskReasonEvidenceOpenModal = useIsPlainModalOpenSelector(
    PlainModals.PRODUCTIVITY_INSIGHTS_MODAL,
  );

  const handleCloseModal = () => {
    dispatch(closeModalByNameAction(PlainModals.PRODUCTIVITY_INSIGHTS_MODAL));
  };

  const [getDataList, { data, isLoading, isError, isFetching }] =
    apiContext.baseApi?.useLazyGetProductivityActionsDataQuery();

  useEffect(() => {
    getDataList({
      startDate: dayjs(sDate).format('YYYY-MM-DD'),
      endDate: dayjs(eDate).format('YYYY-MM-DD'),
      action: metaData?.action,
      teamId: metaData?.teamId,
      type: metaData?.type,
      page,
      limit: itemsPerPage,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [itemsPerPage, page]);

  const memoizedData = useMemo((): any => {
    dispatch(setTotalItems(data?.total));
    return data?.data;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, itemsPerPage, page]);

  return (
    <ModalContainer
      isOpenModal={isRiskReasonEvidenceOpenModal}
      title={
        metaData?.action === 'pull_requests'
          ? `${
              metaData?.type[0]?.toUpperCase() + metaData?.type?.slice(1)
            } Pull Requests`
          : 'Commits'
      }
      handleCloseModal={handleCloseModal}
      modalWidth="1100px"
      modalHeight="600px"
    >
      <ContainerWithLoader isLoading={isLoading} isError={isError}>
        <Box width="100%">
          <TableFiltersContainer>
            <RightTableFiltersContainer>
              {/* <FilterChips tableId={tableId} /> */}
              {/* <SearchInput
              searchQuery={searchQuery}
              setSearchQuery={setSearchQuery}
              dataTestId={PRODUCTIVITY_INSIGHTS_TABLE}
              tableId={tableId}
            /> */}
            </RightTableFiltersContainer>
          </TableFiltersContainer>
          <TableComponent
            tableId={tableId}
            tableHeight="450px"
            isListLoading={isLoading}
            isListErrored={isError}
            isEmptyList={!memoizedData?.length}
            isListFetching={isFetching}
            dataTestId={PRODUCTIVITY_INSIGHTS_TABLE}
            list={memoizedData}
            tableColumns={
              metaData?.action === 'pull_requests'
                ? PullsTableStructure
                : CommitsTableStructure
            }
            extraCellsRenderObj={{}}
          />
        </Box>
      </ContainerWithLoader>
    </ModalContainer>
  );
};
